import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Table, Button, FormControl } from 'react-bootstrap';

import s from './RideFareList.css';
import messages from '../../../../locale/messages';
import CustomPagination from '../../../CustomPagination';
import Link from '../../../Link';

//Images
import EditIcon from '../../../../../public/Icons/edit.png';
import TrashIcon from '../../../../../public/Icons/bin.svg';
import addIcon from '../../../../../public/Icons/addNewIcon.svg';

import updateRideFareStatus from '../../../../actions/siteadmin/RideFare/updateRideFareStatus';
import deleteRideFare from '../../../../actions/siteadmin/RideFare/deleteRideFare';

class RideFareList extends React.Component {
  static propTypes = {
    rideFareDetails: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      searchList: '',
      typingTimeout: 0,
      isDisabled: 0
    };

    this.paginationData = this.paginationData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleSearchClick(searchList) {
    const { rideFareDetails: { refetch } } = this.props;
    this.setState({ currentPage: 1 });
    refetch({ currentPage: 1, searchList });
  }

  handleSearchChange(e) {
    let self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typingTimeout: setTimeout(function () {
        self.handleSearchClick(self.state.searchList);
      }, 450)
    });
  }

  paginationData(currentPage) {
    const { rideFareDetails: { refetch } } = this.props;
    this.setState({ currentPage });
    refetch({ currentPage });
  }

  async handleStatus(e, item) {
    const { updateRideFareStatus, rideFareDetails: { refetch } } = this.props;
    const { currentPage } = this.state;
    let status = e.target.value == 'true' ? '1' : '0';

    // Refetch either way: on a rejected change the row must fall back to the
    // value that is actually stored.
    await updateRideFareStatus(item.id, status, item.locationId, item.categoryId);
    refetch({ currentPage });
  }

  async handleDelete(id) {
    const { deleteRideFare, rideFareDetails: { refetch } } = this.props;

    this.setState({ isDisabled: 1 });
    const response = await deleteRideFare(id);

    if (response && response.status === 200) {
      this.setState({ currentPage: 1 });
      refetch({ currentPage: 1 });
    }
    this.setState({ isDisabled: 0 });
  }

  render() {
    const { rideFareDetails } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, isDisabled } = this.state;

    const fareData = rideFareDetails && !rideFareDetails.loading && rideFareDetails.getAllRideFare;

    return (
      <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
        <div className={cx(s.exportDisplay, s.tabelExport)}>
          <div className={'textAlignRightRTL'}>
            <div className={s.searchInput}>
              <FormControl
                type='text'
                placeholder={formatMessage(messages.search)}
                onChange={(e) => this.handleSearchChange(e)}
                className={s.formControlInput}
              />
            </div>
          </div>
          <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
            <div className={cx(s.paddingTop2)}>
              <Link to={"/siteadmin/ride-fare/add"} className={s.addlinkBtn}>
                {formatMessage(messages.addRideFare)}
                <span className={cx(s.addIconCss, 'addIconCssRTL')}><img src={addIcon} alt='add icon' /></span>
              </Link>
            </div>
          </div>
        </div>
        <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
          <Table className={cx("table")}>
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.location} /></th>
                <th scope="col"><FormattedMessage {...messages.category} /></th>
                <th scope="col"><FormattedMessage {...messages.status} /></th>
                <th scope="col"><FormattedMessage {...messages.updateAt} /></th>
                <th scope="col"><FormattedMessage {...messages.action} /></th>
              </tr>
            </thead>
            <tbody>
              {
                fareData && fareData.count > 0 && fareData.results && fareData.results.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td data-label={formatMessage(messages.id)}>{item.id}</td>
                      <td data-label={formatMessage(messages.location)}>{item.location && item.location.locationName}</td>
                      <td data-label={formatMessage(messages.category)}>{item.category && item.category.categoryName}</td>
                      <td data-label={formatMessage(messages.status)}>
                        <select
                          value={item.isActive}
                          onChange={(e) => { this.handleStatus(e, item) }}
                          className={s.selectInput}
                        >
                          <option value={true}>{formatMessage(messages.active)}</option>
                          <option value={false}>{formatMessage(messages.inactive)}</option>
                        </select>
                      </td>
                      <td data-label={formatMessage(messages.updateAt)}>
                        {moment(moment(new Date(item.updatedAt).toISOString())).format('DD-MM-YYYY hh:mm A')}
                      </td>
                      <td data-label={formatMessage(messages.action)}>
                        <Link to={'/siteadmin/ride-fare/edit/' + item.id} className={cx('editAlignIcon', s.editColorIcon)}>
                          <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} alt='edit icon' /></span>
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.editAction} />
                          </span>
                        </Link>
                        <Button
                          onClick={() => this.handleDelete(item.id)}
                          className={cx(s.iconBtn, 'iconBtnRTL')}
                          disabled={isDisabled}
                        >
                          <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} alt='trash icon' />
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.deleteAction} />
                          </span>
                        </Button>
                      </td>
                    </tr>
                  )
                })
              }
              {
                fareData && fareData.count == 0 && (
                  <tr>
                    <td colSpan="6" className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                )
              }
            </tbody>
          </Table>
        </div>
        {
          fareData && fareData.count > 0 && <div className={cx(s.space5, s.spaceTop5)}>
            <CustomPagination
              total={fareData.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.fares)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  updateRideFareStatus,
  deleteRideFare
};

export default withStyles(s)(injectIntl(connect(mapState, mapDispatch)(RideFareList)));
